export const whitelistAuditTableHeader = [
  {
    name: "Action",
    field: "action",
    align: "left",
    sorting: false,
  },
  {
    name: "Entry",
    field: "entry",
    align: "left",
    sorting: false,
  },
  {
    name: "Change",
    field: "change",
    align: "left",
    sorting: false,
  },
  {
    name: "Actor",
    field: "actor",
    align: "left",
    sorting: false,
  },
  {
    name: "When",
    field: "when",
    align: "left",
    sorting: false,
  },
];

// Human-readable labels for audit actions returned by the API.
export const AUDIT_ACTION_LABELS: Record<string, string> = {
  ENABLE: "Allowlist enabled",
  DISABLE: "Allowlist disabled",
  ENTRY_ADDED: "Entry added",
  ENTRY_REMOVED: "Entry removed",
  ENTRY_UPDATED: "Entry updated",
  ENTRY_ENABLED: "Entry enabled",
  ENTRY_DISABLED: "Entry disabled",
};

export const MAX_LABEL_LENGTH = 100;

// IPv4 / IPv6 / CIDR validation. The server is authoritative (see the 400 rules
// in the API doc), but we surface obvious problems before sending the batch.
const IPV4_REGEX =
  /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

// Reasonably permissive IPv6 matcher (covers compressed :: forms).
const IPV6_REGEX =
  /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

// Returns an error message, or "" when the value is acceptable.
export const validateIpOrCidr = (input: string): string => {
  const value = input.trim();
  if (!value) return "Please enter an IP address or CIDR range";

  const parts = value.split("/");
  if (parts.length > 2) return "Please enter a valid IP address or CIDR range";

  const [addr, prefixStr] = parts;
  const isCidr = parts.length === 2;
  const isV4 = IPV4_REGEX.test(addr);
  const isV6 = IPV6_REGEX.test(addr);

  if (!isV4 && !isV6) {
    return "Please enter a valid IPv4, IPv6 or CIDR value";
  }

  if (isCidr) {
    if (!/^\d+$/.test(prefixStr)) return "Invalid CIDR prefix";
    const prefix = Number(prefixStr);
    const max = isV4 ? 32 : 128;
    if (prefix > max) return `CIDR prefix must be between 0 and ${max}`;
    if (prefix === 0) return "Allow-all ranges (/0) are not permitted";
  }

  // Reject allow-all wildcards (matches the server's 400 rule).
  if (addr === "0.0.0.0" || addr === "::") {
    return "Allow-all addresses are not permitted";
  }

  return "";
};
